// 전화번호 (-) 추가
export function FormatLineNumber(lineNumber) {
  let baseNumber = lineNumber;
  let returnNumber = '';
  let first = '';
  let middle = '';
  let last = '';
  let delimiter = '-';

  if (baseNumber === '' || baseNumber === null || baseNumber === undefined) {
    return '';
  }

  baseNumber = baseNumber.replace('-', '');

  if (baseNumber.startsWith('00')) {
    return baseNumber;
  } else if (baseNumber.startsWith('0')) {
    if (baseNumber.substring(1, 2) === '2') {
      if (baseNumber.length >= 6) {
        first = baseNumber.substr(0, 2);
        last = baseNumber.substr(baseNumber.length - 4);
        middle = baseNumber.substr(2, baseNumber.length - 6);

        returnNumber = first;
        if (middle !== '') {
          returnNumber += delimiter;
        }
        returnNumber += middle;
        if (last !== '') {
          returnNumber += delimiter;
        }
        returnNumber += last;
      }
    } else {
      first = baseNumber.substr(0, 3);
      last = baseNumber.substr(baseNumber.length - 4);

      if (baseNumber.length === 11) {
        middle = baseNumber.substr(3, 4); //휴대폰번호 - 가운데 4자리
      } else {
        middle = baseNumber.substr(3, 3); //일반 전화 - 가운데 3자리
      }

      returnNumber = first;
      if (middle !== '') {
        returnNumber += delimiter;
      }
      returnNumber += middle;
      if (last !== '') {
        returnNumber += delimiter;
      }
      returnNumber += last;
    }
  } else if (baseNumber.startsWith('1') && baseNumber.length === 8) {
    //8자리 전화번호
    first = baseNumber.substring(0, 4);
    last = baseNumber.substring(baseNumber.length - 4);

    returnNumber = first + delimiter + last;
  } else {
    returnNumber = baseNumber;
  }

  return returnNumber;
}

export function FormatNumber(number) {
  if (number !== undefined) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  else {
    return 0;
  }
  
}

export function InputOnlyNumber(event, refCurrent) {
  event.target.value = event.target.value.replace(/[^0-9]/g, '');

  if (refCurrent && event.target.value.length === event.target.maxLength) {
    refCurrent.instance.focus();
  }
}

export function ConvertDateFormat(inputDate) {
  var year = inputDate.substring(0, 4);
  var month = inputDate.substring(4, 6);
  var day = inputDate.substring(6, 8);

  var outputDate = year + '-' + month + '-' + day;

  return outputDate;
}

export function ConvertDateTimeFormat(inputDate) {
  var year = inputDate.substring(2, 4);
  var month = inputDate.substring(4, 6);
  var day = inputDate.substring(6, 8);
  var hour = inputDate.substring(8, 10);
  var minute = inputDate.substring(10, 12);
  var second = inputDate.substring(12, 14);

  var outputDateTime = year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second;

  return outputDateTime;
}

